import { createEventListener } from "../../utils/events/trackComponent";
import { trackGAEvents } from "../../utils/events/ga";

const closeTopalert = document.querySelector(".js-topalert-close");
const clickSabrosona = document.querySelector(".js-ga-alert");

// GA tracking for click alerts

if (closeTopalert) {
  createEventListener(
    closeTopalert,
    () => {
      trackGAEvents("click-user-alert", "close");
    },
    "click"
  );
}

if (clickSabrosona) {
  createEventListener(
    clickSabrosona,
    () => {
      trackGAEvents("click-user-alert", "click");
    },
    "click"
  );
}
